import React, { useEffect, useState } from 'react';
import { BsClipboardPlus } from 'react-icons/bs';
import { NotificationManager } from 'react-notifications';
import { Tooltip } from 'react-tooltip';
import { _$ } from '../../../../controllers/dom';
import { locales } from '../../../../translations/locales';
import Loading from '../../../Loading';

const ManageSkill = (props) => {
    const { theme, locale, ModuleRP, data } = props;
    const [confirmDelete, setConfirmDelete] = useState(false);
    const copyClipboard = () => {
        navigator.clipboard.writeText(data.id)
            .then(() => {
                NotificationManager.success(locales[locale].notifications.copySuccess, '', 3000);
            })
            .catch(() => {
                NotificationManager.error(locales[locale].notifications.copyError, '', 3000);
            });
    };
    const updateSkill = () => {
        if (!_$('skillName').value) {
            _addClass('skillName', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        const params = ['id', 'name'];
        const values = [data.id, _$('skillName').value];
        ModuleRP.config.updateSkill(params, values);
    };

    useEffect(() => {

    }, [data]);

    return (
        data.type === 'skill' ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">{locales[locale].config.manageSkill}</h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <form onSubmit={(event) => {
                            event.preventDefault();
                            updateSkill();
                        }}>
                            <div className='form-group'>
                                <label htmlFor='skillName'>
                                    {locales[locale].config.skillName}
                                    <span className='text-info m-1'>{locales[locale].config.required}</span>
                                </label>
                                <input
                                    type='text'
                                    id='skillName'
                                    className='form-control w-100'
                                    placeholder={locales[locale].config.skillName}
                                    defaultValue={data.name}
                                />
                                <div className="card-text text-secondary">
                                    <span className={`text-${theme === 'DARK' ? 'light' : 'dark'}`}>
                                        {data.id}
                                    </span>
                                    <span
                                        className={`text-${theme === 'DARK' ? 'light' : 'dark'} m-1 cursor-pointer`}
                                        data-tip data-tooltip-id='copy'
                                        onClick={copyClipboard}
                                    >
                                        <BsClipboardPlus />
                                        <Tooltip id='copy' place='top' effect='solid' className='text-center'>
                                            {locales[locale].config.copyClipboard}
                                        </Tooltip>
                                    </span>
                                </div>
                            </div>
                        </form>
                        <button
                            type='button' id='btn-confirm-update-skill' className="btn btn-primary float-right" onClick={updateSkill}>
                            {locales[locale].config.update}
                        </button>
                    </div>
                </div>
                <div className="card container p-0 gameInformations mt-5 mb-2">
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <div className="row">
                            <div className="col-sm-8"></div>
                            <div className='col h-25 btn btn-danger' onClick={() => setConfirmDelete(true)}>
                                {locales[locale].config.deleteSkill}
                            </div>
                        </div>
                        <div className={confirmDelete ? '' : 'hide'} id="deleteSkill">
                            <hr className={`m-1 bg-secondary`} />
                            <div>
                                {locales[locale].config.deleteConfirmSkill}
                            </div>
                            <div className="text-center">
                                <button className='btn btn-sm btn-secondary w-25 m-3' onClick={() => setConfirmDelete(false)}>
                                    {locales[locale].no}
                                </button>
                                <button
                                    className='btn btn-sm btn-danger w-25 m-3'
                                    id='btn-delete-skill'
                                    onClick={() => {
                                        ModuleRP.config.deleteSkill(data.id);
                                    }}
                                >
                                    {locales[locale].yes}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default ManageSkill;
